import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onBookmarkFetchFailed: () => AnalyticsEventPayload = (): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: 'aiSearchBookmarkAddDismiss',
			eventType: 'track',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onBookmarkFetchFailed' });
		return {};
	}
};
